import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {CategoriesModelService} from '../../Models/Core/categories-model.service';

@Injectable({
  providedIn: 'root'
})
export class CategoriesApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: CategoriesModelService
  ) {
    super(injector);
  }


  /**
   * Obtener las partidas
   *
   */
  public getCategories(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPartidas', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
